// extracted by mini-css-extract-plugin
module.exports = {"container":"about__container","imageContainer":"about__imageContainer","textContainer":"about__textContainer","content":"about__content"};